import { render, staticRenderFns } from "./paidPlan.vue?vue&type=template&id=76c53045&scoped=true"
import script from "./paidPlan.vue?vue&type=script&lang=js"
export * from "./paidPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c53045",
  null
  
)

export default component.exports